module.exports = __webpack_public_path__ + "img/banner.359b0c7e.png";